import React from "react";
import {Box} from '@mui/material';
import CustomAppBar from '../components/appbar';
import Prequalification from "../components/Prequalification";

const PrequalificationsCard = () => {
    return (
        <Box>
            <CustomAppBar active="prequalifications"/>
            <Prequalification/>
        </Box>
    );
}

export default PrequalificationsCard;